export const onboarding = {
  intro: {
    heading: (args: { appName: string }) =>
      `${args.appName}は全国の女の子と\n話せるアプリです。`,
    subheading: "好みの女の子を見つける\nお手伝いさせてください。",
    start: "好みを見つける",
    skip: "スキップ",
  },
  bridge: {
    message: "まずはあなたの\n好みのタイプと\n興奮するタイプを教えて",
    hint: "タップで次へ（3秒後に自動で進みます）",
  },
  preferences: {
    heading: "好みのタイプと\n興奮するタイプは？",
    hint: "未選択の項目は「どっちも」のままでOK",
    both: "どっちも",
    rows: {
      bustSize: { left: "貧乳", mid: "普通", right: "巨乳" },
      personality: { left: "Sっぽい", right: "Mっぽい" },
      age: { left: "J○", right: "熟女" },
      marriage: { left: "未婚", right: "人妻" },
      style: { left: "ギャル", right: "清楚" },
    },
    submit: "好みの女の子情報を送信",
  },
  analyzing: {
    title: "あなたの好みを解析中",
    subtitle: "好みのデータとマッチング中…",
  },
  results: {
    heading: "あなたの好みに合いそうな女の子",
    hint: "気になる子にチェックを付けていいねしてみませんか？",
    sendLabel: (args: { count: number }) => `♥ ${args.count}人にいいねを送る`,
    selectPrompt: "気になる子を選んでね",
  },
  likeSent: {
    label: (args: { count: number }) => `${args.count}人にいいねを送りました！`,
  },
  bubbles: {
    heading: "いいねを送った女の子たち",
    hint: "アイコンをタップするとプロフィールが見れます",
    cta: "女の子と話にいこう",
  },
} as const;
